import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const WarningBase = (
  <path
    fill='currentColor'
    d='M11.19 4a2 2 0 0 0-1.992 2.181l.637 7A2 2 0 0 0 11.826 15h.348a2 2 0 0 0 1.991-1.819l.637-7A2 2 0 0 0 12.81 4h-1.62zM12 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4z'
  />
)

export const Warning = createIcon({
  displayName: 'Warning',
  viewBox: '0 0 24 24',
  path: WarningBase,
})
